// en, pt
export default {
  pt: {
    names: {
      street_name: 'Logradouro',
      federation_unit: 'Estado',
      born_city_id: 'Cidade',
      address_type_id: 'Tipo de Endereço',
      calendar: 'Calendário',
      title: 'Título'
    },
    Dashboard: 'Dashboard',
    Users: 'Usuários',
    name: 'Nome',
    email: 'Email',
    grid: 'Listagem',
    'grid.id': 'ID',
    'grid.status': 'Situação',
    display_name: 'Grupo',
    description: 'Descrição',
    permissions_name: 'Display Nome',
    confirmacao: 'Confirmação',
    confirmacao_edita_form_: 'Confirmação a Alteração do Formulário?',
    permissions_description: 'Descrição',
    Files: 'Arquivos',
    Roles: 'Grupos',
    Integration: 'Integração',
    IntegrationAccesses: 'Acessos S2S',
    Integrations: 'Integrações S2S',
    IntegrationUrls: 'URLs',
    validation: 'Validação',
    Functionalities: 'Funcionalidades',
    form_min_caracter: 'Digite ao menos 10 caracteres...',
    form_min_caracter_: 'Digite ao menos {0} caracteres...',
    receiving_emails: 'Recebimento de e-mails',
    user_access_data: 'Dados do acesso do solicitante',
    public_preview: 'Visualização pública',
    preview: 'Visualização',
    public: 'Público',
    private: 'Privado',
    total_items: 'Total de itens',
    messages:{
      success: 'Operação realizada com sucesso!',
      success_title: 'Successo!',
      form_field_invalid: 'Preencha corretamente os campos do formulário',
      error: 'Operação não pode ser realizada. Contacte o administrador do sistema!',
      add_email_valid: 'Adicione somente e-mails válidos!',
      confirm_deletion: "Tem certeza que deseja excluir este registro?",
      field_requerid: "Este campo é obrigatório!",
      field_invalid: "Este campo está inválido!",
    },
    action: {
      add: 'Adicionar',
      ok: 'OK',
      yes: 'Sim',
      no: 'Não',
      send: 'Enviar',
      send_pending: 'Enviar pendente',
      search: 'Buscar',
      cancel: 'Cancelar',
      create: 'Criar',
      store: 'Armazenar',
      save: 'Salvar',
      clear: 'Limpar',
      customize: 'Personalizar',
      edit: 'Editar',
      delete: 'Excluir',
      remove: "Remover",
      consult: 'Consultar',
      activate: 'Ativar',
      reset_password: 'Recuperar Senha',
      change_password: 'Trocar Senha',
      reload: 'Recarregar',
      confirm: 'Confirmar',
      import_unit: 'Importar Unidade(s)',
      go_back: "Voltar",
      back: "Voltar",
      manage: "Gerenciar",
      download: "Baixar",
      download_all: "Baixar Todos",
      copy: 'Copiar',
      copy_link: 'Copiar Link',
      send_comment: 'Enviar comentário',
      like: 'Curtir',
      colaboration: 'Colaboração',
      clone_by_group: 'Clonar por Grupo',
      clone_by_subgroup: 'Clonar por Subgrupo',
      clone_newsletter_by_group: 'Clonar Informativo por Grupo',
      clone_newsletter_by_subgroup: 'Clonar Informativo por Subgrupo',
      signature: 'Assinar',
      sign_reading: 'Assinar Leitura',
      close: 'Fechar',
      view_signatures: 'Visualizar assinaturas',
      report: 'Relatório',
      generate_report: 'Gerar Relatório',
      generate_statistics: 'Gerar Estatísticas',
      clone: 'Clonar',
      detail: 'Detalhar',
      send_report: 'Enviar Relatório',
      export_pdf: 'Exportar PDF',
      export_excel: 'Exportar Excel',
      search_contact: 'Buscar Contato',
    },
    acl: {
      menu: 'Segurança'
    },
    role: {
      selected: 'Grupos selecionados',
      name: 'Grupo',
      display_name: 'Grupo',
      description: 'Descrição'
    },
    module: {
      menu: 'Módulo',
      title: 'Módulo',
      subtitle: 'Módulo',
      name: 'Nome',
      description: 'Descrição'
    },
    functionality: {
      menu: 'Funcionalidade',
      title: 'Funcionalidade',
      titles: 'Funcionalidades',
      subtitle: 'Funcionalidade',
      name: 'Nome',
      description: 'Descrição',
      module: 'Módulo'
    },
    permission: {
      menu: 'Permissão',
      title: 'Permissão',
      titles: 'Permissões',
      subtitle: 'Permissão',
      name: 'Nome',
      display_name: 'Display name',
      guard_name: 'Guard name',
      description: 'Descrição'
    },

    genders: {
      male: 'Masculino',
      female: 'Feminino',
      undisclosed: 'Outro'
    },

    schedule_guest: {
      situation: {
        CON: 'Confirmado',
        REJ: 'Rejeitado',
        PEN: 'Pendente',
        CONREJ: 'Confirmado e Rejeitado 🤔'
      }
    },

    guests_confirmed: 'Nenhum convidado confirmou esta data | 1 convidado confirmou esta data | {0} convidados confirmaram esta data',
    guests_rejected: 'Nenhum convidado rejeitou esta data | 1 convidado rejeitou esta data | {0} convidados rejeitaram esta data',

    // People
    People: 'Pessoas',
    NaturalEntity: 'Pessoa Natural',
    LegalEntity: 'Pessoa Jurídica',

    // General
    actions: 'Ações',
    AddNew: 'Novo',
    pages: 'Páginas',
    save: 'Salvar',
    add: 'Adicionar',
    edit: 'Editar',
    back: 'Voltar',
    delete: 'Excluir',
    close: 'Fechar',
    pending: 'Pendente',
    closed: 'Encerrar',
    new_unit: 'Nova Unidade',
    send: 'Enviar',
    back_to_home: 'Voltar',
    login: 'Login',
    click_here: 'Clique aqui',
    under_maintenance: 'Estamos em Manutenção',
    handling_form: 'Tratar formulário',
    print_or_generate_pdf: 'Imprimir / Gerar PDF',
    yes: 'Sim',
    no: 'Não',
    date_hour: 'Data/hora',
    status: 'Situação',
    handling: 'Tratamento',
    other: 'Outro',
    when_applicable: 'Quando aplicável',

    // Natural Entity
    natural_entities_first_name: 'Nome',
    natural_entities_surname: 'Sobrenome',
    natural_entities_gender: 'Sexo',
    natural_entities_birth_date: 'Data Nascimento',

    // Legal Entity
    legal_entities_cnpj: 'CNPJ',
    legal_entities_trading_name: 'Nome Fantasia',
    legal_entities_company_name: 'Razão Social',
    legal_entities_unit: 'Instituição/Unidade',

    // Employee
    Employee: 'Colaborador',
    Employees: 'Colaboradores',
    position: 'Cargo',

    form_handling: 'Tratamento',
    form_handling_preview: 'Visualização (Tratamento)',
    form_history_handling: 'Histórico de tratamento',
    session_timeout: {
      title: 'Sessão encerrada',
      expired: 'Sua sessão foi encerrada por inatividade. Faça login novamente.',
      remaining: 'Sessão encerra por inatividade em {time}',
      label: 'Sessão',
      warning_title: 'Sessão prestes a expirar',
      warning_message: 'Você está inativo. Clique em renovar para continuar na plataforma.',
      renew: 'Renovar sessão',
      go_to_login: 'Ir para o login'
    },
    last_access: {
      status: {
        success: 'Sucesso',
        failed: 'Falhou',
        unauthorized: 'Não Autorizado'
      },
      title: 'Último Acesso',
      date_time: 'Data/Hora',
      ip: 'IP',
      email: 'E-mail',
      browser: 'Navegador',
      platform: 'Plataforma',
      device: 'Dispositivo',
      user_agent: 'User Agent',
      logout_at: 'Data/Hora Logout',
      no_access_found: 'Nenhum acesso anterior encontrado.',
      device_types: {
        mobile: 'Mobile',
        tablet: 'Tablet',
        desktop: 'Desktop'
      }
    },
    forwarding_description: 'Encaminhamento',
    forwarding_description_public: 'Encaminhamento (público)',

    //PrivacyForm
    privacyFormTitle: 'Formulário de Privacidade',
    privacyFormHandlingTitle: 'Formulário de Privacidade',
    privacy_form_handling_sub_title: 'Tratamento',
    privacy_form_protocol: 'Protocolo',
    created_date_formatted: 'Solicitado em',
    created_formated: 'Solicitado em',
    validated_date_formatted: 'Validado em',
    status_str: 'Situação',
    privacy_form_request: 'Solicitação',
    privacy_form_handling: 'Tratamento',
    privacy_form: 'Formulário',
    privacy_form_requester: 'Solicitante',
    privacy_form_bond_type: 'Natureza do vínculo',
    privacy_form_unity: 'Unidade',
    privacy_form_name: 'Name',
    privacy_form_document: 'CPF/CRNM (RNE)',
    privacy_form_phone: 'Telefone',
    privacy_form_email: 'E-mail',
    privacy_form_country: 'País',
    privacy_form_legal_document: 'CNPJ',
    privacy_form_birth_date: 'Data nascimento',
    privacy_form_treatment: 'Atendimento',
    privacy_form_status: 'Situação',
    privacy_form_in_validation: 'Em validação',
    privacy_form_validated: 'Validado',
    privacy_form_history_handling: 'Histórico de tratamento',
    privacy_form_min_caracter: 'Digite ao menos 10 caracteres...',
    privacy_form_description: 'Descrição da solicitação',

    // ScheduleForm
    schedulesTitle: 'Agendamentos',

    //Form incident
    incident_form: {
      title: 'Formulário de Incidente',
      title_01: '1. Identificação e Responsáveis',
      title_02: '2. Caracterização do Incidente',
      title_03: '3. Dados Pessoais Afetados',
      title_04: '4. Linha do Tempo do Incidente',
      title_05: '5. Medidas e Ações',
      title_06: '6. Comunicação e Relato à ANPD',
    },

    incidentFormTitle: 'Formulário de Incidente',
    incident_form_description: 'Descrição da solicitação',
    incident_form_min_caracter: 'Digite ao menos 10 caracteres...',

    incident_form_responsible_email: 'E-mail do responsável pelo formulário (para acompanhamento)',
    incident_form_date: 'Data do Incidente',
    incident_form_when: 'Quando a organização teve ciência do incidente de segurança',
    incident_form_type: 'Tipo de Incidente',
    incident_form_unit: 'Unidade',
    incident_form_area: 'Área',
    incident_form_involved: 'Envolvidos no Incidente',
    incident_form_name_tel_email: '(Nome, telefone, e-mail)',
    incident_form_responsible_unit: 'Responsável pela Unidade',
    category_personal_data: 'Categoria de dados pessoais (contexto)',
    number_affected_holders: 'Número de titulares afetados',
    incident_form_group: 'Grupo',
    incident_form_leaked_content: 'Natureza dos dados pessoais',
    incident_form_data_protection_measures: 'Medidas técnicas e de segurança',
    incident_form_data_protection_measures_01: 'Utilizadas para a proteção dos dados pessoais, adotadas antes e após o incidente',
    incident_form_related_risks: 'Riscos relacionados ao incidente com identificação dos possíveis impactos aos titulares',
    incident_form_reasons_delay: 'Motivos da demora',
    incident_form_actions_reverse_incident: 'Medidas que foram ou que serão adotadas para reverter ou mitigar os efeitos do incidente sobre os titulares',
    incident_form_date_authority: 'Data de seu conhecimento pelo controlador',
    incident_form_date_operator: 'Data de seu conhecimento pelo operador',
    incident_form_date_incident: 'Data da ocorrência do incidente, quando possível determiná-la',
    incident_form_data_authority_description: 'Dados do encarregado ou de quem represente o controlador',
    incident_form_authority_identification: 'Identificação do controlador',
    incident_form_operator_identification: 'Identificação do operador',
    incident_form_description_incident: 'Descrição do incidente',
    incident_form_root_cause: 'Incluindo a causa principal, caso seja possível identificá-la',
    incident_form_total_affected_holders: 'Total de titulares',
    incident_form_total_affected_holders_01: 'Cujos dados são tratados nas atividades de tratamento afetadas pelo incidente',
    incident_form_comunication_content: 'A forma e o conteúdo da comunicação, se o incidente tiver sido comunicado à ANPD e aos titulares',
    incident_form_communication_content_attachments: 'Anexos referentes à comunicação',
    incident_form_reasons_lack_communication: 'Os motivos da ausência de comunicação, quando for o caso',
    incident_form_affected: 'Pilar de segurança afetado',
    incident_form_structure_organization_description: 'Descrição da área da estrutura organizacional atingida',
    incident_form_data_old_or_new: 'Os dados envolvidos no incidente são Atuais ou Antigos',
    incident_form_who_reported: 'Quem reportou o Incidente',
    incident_form_how_identified: 'Como o incidente foi detectado',
    incident_form_holders_report: 'Algum titular de dados reportou o incidente',
    incident_form_case_yes_contact: 'Se sim informar dados de contato do titular de dados',
    incident_form_anpd_report_incident: 'Autoridade Nacional de Proteção de Dados Reportou o incidente',
    incident_form_anpd_communicated: 'Deve ser comunicado à ANPD',
    incident_form_other_description: 'Outras informações',
    incident_form_other_description_01: 'Pertinentes ao incidente',
    incident_form_additional_information: 'Informações Adicionais',
    incident_form_attachments: 'Anexos',
    incident_form_protocol: 'Protocolo',
    incident_form_request: 'Solicitação',
    incident_form_handling: 'Tratamento',
    incident_form_treatment: 'Atendimento',
    incident_form_status: 'Situação',
    incident_form_in_validation: 'Em validação',
    incident_form_validated: 'Validado',
    incident_form_history_handling: 'Histórico de tratamento',
    type_form: 'Formulário',
    type_form_general: 'Registro de Incidente',
    type_form_coup_attempt: 'Registro de tentativa de golpe/fraude',
    coup_attempt_type: 'Tipo de tentativa de golpe ou fraude',
    incident_form_date_coup_attempt: 'Data da ocorrência da tentativa de golpe/fraude',
    incident_form_description_coup_attempt: 'Descrição da tentativa de golpe/fraude',
    incident_form_who_reported_coup_attempt: 'Quem reportou a tentativa de golpe/fraude',

    msg_none: 'Nenhum registro encontrado!',
    msg_none_file: 'Nenhum arquivo anexado!',

    dueDiligenceFormTitle: 'Due Diligence',

    knowledge_subtitle_document : 'Documento(s)',
    knowledge_item_title: 'Título',
    knowledge_item_category: 'Categoria',
    knowledge_item_subject: 'Assunto',
    knowledge_item_description: 'Descrição',

    document_title_document : 'Documento',
    document_subtitle_document : 'Documento(s)',
    document_title: 'Título',
    document_category: 'Categoria',
    document_subject: 'Assunto',
    document_description: 'Descrição',
    document_password: 'Senha',
    document_destination: 'Destinatário',
    document_destination_name: 'Nome',
    document_destination_email: 'E-mail',
    document_destination_search_contact: 'Buscar',
    document_security: 'Segurança',
    document_colaboration: 'Quem pode consultar/editar documentos (grupos)',
    document_access_by_code: 'Acesso por Token (enviado para o e-mail do destinatário)',
    document_token: 'Token',
    document_public: 'Público',
    document_private: 'Privado',
    document_access: 'Acesso',
    document_validate_token: 'Validar token de acesso ao documento',
    document: {
      messages:{
        envio_pendente_disparado: 'Os envios pendentes serão disparados!',
        enter_token: 'Informe corretamente o token (código) que recebeu em seu e-mail, para ter acesso ao(s) documento(s).'
      }
    },
    systematic_intimidation:{
      title: 'Intimidação Sistemática',
      unit: 'Unidade',
      link_profile: 'Link/Perfil',
      description: 'Descrição',
      protocol_number: 'Protocolo',
      status: 'Situação',
      history_handling: 'Histórico de tratamento',
      handling: 'Tratamento',
      history: 'Histórico',
      created_at: 'Solicitado em',
      institution_unity: 'Instituição/Unidade',
      general_orientation: 'Orientação para o preenchimento'
    },
    reporting_channel:{
      title: 'Formulário de Relato',
      sub_title: 'Formulário Preenchido',
      unit: 'Unidade',
      description: 'Descrição',
      protocol_number: 'Protocolo',
      status: 'Situação',
      severity_level: 'Nível de Criticidade',
      history_handling: 'Histórico de tratamento',
      handling: 'Tratamento',
      history: 'Histórico',
      menu: {
        title: 'Formulário de Relato',
        dashboard: 'Dashboard',
        screening: 'Triagem',
        handling: 'Tratamento',
        configuration: 'Configuração',
        reports: {
          title: 'Relatórios',
          response_time: 'Tempo de Atendimento',
          type_reporting: 'Por Tipo de Relato',
          identification: 'Por Identificação',
          severity: 'Por Nível de Criticidade'
        }
      },
      reports: {
        response_time: {
          title: 'Relatório de Tempo de Atendimento',
          subtitle: 'Análise do tempo de atendimento dos formulários de relato',
          history_title: 'Histórico de Tratamento',
          protocol: 'Protocolo',
          handling_id: 'ID do Tratamento',
          institution_not_informed: 'Instituição não informada',
          no_data_message: 'Nenhum registro encontrado. Aplique os filtros e clique em "Buscar" para visualizar os dados.',
          pdf_export_title: 'Exportação PDF',
          pdf_export_message: 'Funcionalidade de exportação PDF será implementada em breve.',
          export_pdf: 'Exportar PDF',
          filters: {
            legal_entity: 'Pessoa Jurídica',
            protocol_number: 'Número do Protocolo',
            protocol_number_placeholder: 'Digite o protocolo',
            start_date: 'Data Inicial',
            start_date_placeholder: 'Selecione a data inicial',
            end_date: 'Data Final',
            end_date_placeholder: 'Selecione a data final',
            search_button: 'Buscar dados do relatório'
          },
          table: {
            status: 'Situação',
            treatment_date: 'Data do Tratamento',
            time_in_status: 'Tempo de Atendimento',
            user: 'Usuário'
          }
        },
        type_reporting: {
          title: 'Relatório por Tipo de Relato',
          subtitle: 'Análise dos formulários de relato por tipo',
          no_data_message: 'Nenhum registro encontrado. Aplique os filtros e clique em "Buscar" para visualizar os dados.',
          export_pdf: 'Exportar PDF',
          filters: {
            legal_entity: 'Pessoa Jurídica',
            start_date: 'Data Inicial',
            start_date_placeholder: 'Selecione a data inicial',
            end_date: 'Data Final',
            end_date_placeholder: 'Selecione a data final',
            search_button: 'Buscar dados do relatório'
          },
          table: {
            type_reporting: 'Tipo de Relato',
            total: 'Total',
            percentual: 'Percentual'
          },
          total_geral: 'Total Geral'
        },
        identification: {
          title: 'Relatório por Identificação',
          subtitle: 'Análise dos formulários de relato por identificação',
          no_data_message: 'Nenhum registro encontrado. Aplique os filtros e clique em "Buscar" para visualizar os dados.',
          export_pdf: 'Exportar PDF',
          filters: {
            legal_entity: 'Pessoa Jurídica',
            start_date: 'Data Inicial',
            start_date_placeholder: 'Selecione a data inicial',
            end_date: 'Data Final',
            end_date_placeholder: 'Selecione a data final',
            search_button: 'Buscar dados do relatório'
          },
          table: {
            identification_status: 'Situação de Identificação',
            total: 'Total',
            percentual: 'Percentual'
          },
          total_geral: 'Total Geral'
        },
        severity: {
          title: 'Relatório por Nível de Criticidade',
          subtitle: 'Análise dos formulários de relato por nível de criticidade',
          no_data_message: 'Nenhum registro encontrado. Aplique os filtros e clique em "Buscar" para visualizar os dados.',
          export_pdf: 'Exportar PDF',
          filters: {
            legal_entity: 'Pessoa Jurídica',
            start_date: 'Data Inicial',
            start_date_placeholder: 'Selecione a data inicial',
            end_date: 'Data Final',
            end_date_placeholder: 'Selecione a data final',
            search_button: 'Buscar dados do relatório'
          },
          table: {
            severity_label: 'Nível de Criticidade',
            total: 'Total',
            percentual: 'Percentual'
          },
          total_geral: 'Total Geral'
        }
      },
      created_at: 'Solicitado em',
      institution_unity: 'Instituição/Unidade',
      general_orientation: 'Orientação para o preenchimento',
      url_to_form: 'URL Formulário de Relato',
      important: 'Importante!',
      report_channel_exclusive: 'Este canal é exclusivo para comunidade da(o) {0}!',
      screening: 'Triagem',
      workflow_config: {
        title: 'Configuração de Fluxo',
        description: 'Descrição',
        description_placeholder: 'Digite a descrição do fluxo de configuração',
        legal_entity: 'Pessoa Jurídica',
        legal_entity_placeholder: 'Digite o nome ou cnpj da pessoa jurídica',
        legal_entity_hint: 'Deixe vazio para configuração global',
        created_at: 'Data de Criação',
        basic_tab: 'Dados Básicos',
        deadlines_tab: 'Configuração de Prazos',
        destinations_tab: 'Destinatários',
        destinations: {
          name: 'Nome',
          email: 'E-mail',
        },
      },
      deadline_config: {
        title: 'Configuração de Prazos de Tratamento',
        tab_title: 'Configuração de Prazos',
        handling_status: 'Situação de Tratamento',
        deadline_days: 'Prazo (dias)',
        is_business_days: 'Tipo de Prazo',
        business_days: 'Dias Úteis',
        calendar_days: 'Dias Corridos',
        entity_type: 'Tipo de Entidade',
        entity_id: 'ID da Entidade',
        legal_entity: 'Pessoa Jurídica',
        create: 'Criar Configuração',
        edit: 'Editar Configuração',
        delete: 'Excluir Configuração',
        detail: 'Detalhar Configuração',
        destinations: {
          tab_title: 'Destinatários',
          name: 'Nome',
          email: 'E-mail',
        },
      },
      form:{
        field01: 'Você gostaria de se identificar',
        field01_01: 'Nome',
        field01_02: 'CPF',
        field01_03: 'E-mail',
        field01_04: 'Telefone',
        field01_05: 'Identificação',
        field02: 'Qual a sua relação?',
        field02_: 'Qual a sua relação com a instituição {0}',
        field03: 'Qual o tipo de denúncia melhor se enquadra ao fato que você está registrando?',
        field04: 'Indique a empresa do grupo onde ocorreu o fato que você está denunciando:',
        field05: 'Indique a área/setor onde ocorreu o fato que você está denunciando:',
        field06: 'Como teve conhecimento do fato/transgressão que irá relatar?',
        field07: 'Sobre a situação que irá relatar, você:',
        field08: 'O que você quer denunciar?',
        field08_01: 'Descreva o mais detalhadamente possível o que aconteceu, indicando:',
        field08_02: 'O nome da(s) pessoa(s) que está(ão) envolvida(s) ou que presenciaram a situação.\n Quando a situação ocorreu.\n Há quanto tempo a situação vem ocorrendo.\n Quantas vezes a situação ocorreu.\n Os comportamentos ou métodos utilizados pelos denunciados.',
        field09: 'A situação relatada continua acontecendo? Quando foi a última vez?',
        field10: 'A situação que você está denunciando já aconteceu antes, inclusive com outras pessoas? Caso positivo, cite quando e com quem.',
        field11: 'Outras pessoas tem conhecimento ou presenciaram a situação? Em caso positivo, cite os nomes e o departamento em que trabalham.',
        field12: 'Existem evidências/provas sobre o fato?',
        field12_01: 'Em caso positivo, pedimos que as compartilhe conosco ou indique onde podemos obtê-las.\n Quais e em que lugar(es) podem ser encontradas evidências sobre o fato denunciado?\n Existem documentos que comprovam esse fato? Em caso positivo, onde podem ser encontrados? Especifique da forma mais detalhada possível.\n Lembre-se: qualquer informação pode ser útil, por mais irrelevante que ela pareça para você.',
        field12_02: 'ATENÇÃO: NÃO REMOVA/EXCLUA OU MANUSEIE QUALQUER EVIDÊNCIA OU PROVA, POIS A INVESTIGAÇÃO PODE SER PREJUDICADA.',
        field13: 'Quer indicar algum site, perfil na Internet, grupo de whatsapp para ser consultado?',
        field14: 'Por que você está denunciando esta situação?',
        field15: 'Como poderíamos confirmar ou investigar a situação relatada?',
        field16: 'Algum colaborador com cargo de gestão (Diretor, Gerente, Coordenador, Supervisor) tem CONHECIMENTO da situação relatada?',
        field17: 'Caso seja possível, indique o valor financeiro envolvido no fato relatado:',
      }
    },
    parameters: {
      menu: {
        title: 'Parâmetros'
      }
    },
    protocol_query:{
      title: 'Consulta de protocolo',
      protocol_number: 'Número do Protocolo',
      msg_status_public_confirm: 'Tem certeza que deseja deixar o tratamento como Público? Essa situação e tratamento será disponilizado para consulta pública do protocolo!',
      history: 'Histórico de consulta pública',
    },
    newsletter:{
      title: 'Informativo',
      status: 'Situação',
      link: 'Link (customizável)',
      created_at: 'Solicitado em',
      allows_comment: 'Permite comentar',
      allows_enjoy: 'Permite curtir',
      allows_signature: 'Permite assinar',
      content: 'Conteúdo',
      comment_moderate: 'Moderar Comentários',
      view: 'Visualizações',
      like: 'Curtidas',
      comment: 'Comentários',
      comment_total: 'Comentários (total)',
      comment_without_moderator: 'Comentários (sem moderador)',
      status_: {
        'DR': 'Rascunho',
        'RE': 'Liberado',
      },
      comments:{
        title: 'Comentários',
        add_comment: 'Adicionar um comentário (moderado)',
        not_found: 'Nenhum comentário até o momento.',

      },
      sign_reading: 'Assinar Leitura',
      sign_reading_description: 'Assinar Leitura',
      signature_name: 'Nome',
      signature_email: 'E-mail',
      signature_signed_at: 'Assinado em',
      no_signatures_found: 'Este informativo não possui assinaturas ainda.',
      workflow:{
        title: 'Workflow',
        name: 'Nome',
        description: 'Descrição',
        timeline: 'Cronograma',
        report: 'Relatório',
        data_basic: 'Dados Básicos',
        report_title: 'Título do Relatório',
        report_subtitle: 'Sub Título do Relatório',
        report_cover_text: 'Texto da capa do Relatório',
        destination: 'Destinatário(s)',
        destination_name: 'Nome',
        destination_email: 'E-mail',
        destination_search_contact: 'Buscar',
        destination_search_contact_placeholder: 'Buscar destinatário(s)',
        report_config: 'Configuração do Relatório',
        text_against_layer: 'Texto contra capa',
        messages: {
          envio_pendente_disparado: 'Os envios pendentes serão disparados!',
        },
        checkpoint: {
          title: 'Ponto de verificação',
          add_date: 'Adicionar data',
          no_dates: 'Nenhuma data adicionada',
          add_date_placeholder: 'Adicionar data',
          description: 'Configuração de ponto de verificação automático.',
          no_checkpoints_configured: 'Nenhum ponto de verificação configurado para este cronograma',
        }
      }
    },
    group_news:{
      menu: 'Grupo de notícias',
      title: 'Grupo de notícias',
      name: 'Nome',
      group: 'Grupo',
      description: 'Descrição'
    },
    subgroup_news:{
      menu: 'Subgrupo de notícias',
      title: 'Subgrupo de notícias',
      name: 'Nome',
      subgroup: 'Subgrupo',
      description: 'Descrição'
    },
    portal_cebas: {
      credentialing: {
        title: 'Credenciamento',
        config: 'Configuração de credenciamento',
        title_page: 'Título da página inicial',
        color: 'Cor da página pública (em Hex)',
        link: 'Link público do credenciamento (customizável)',
        info_page: 'Informações da página inicial do credenciamento',
        legal_entity: 'Instituição',
        title_page_public: 'CEBAS - Solicitação de credenciamento',
      },
      vacancies: {
        title: 'Vagas',
        config: 'Configuração de vagas',
        name: 'Nome',
        color: 'Cor da página pública (em Hex)',
        link: 'Link público das vagas (customizável)',
        info_page: 'Informações da página inicial das vagas'
      }
    },
    common: {
      period_filters: {
        quick_periods: 'Períodos rápidos',
        today: 'Hoje',
        yesterday: 'Ontem',
        last_7_days: 'Últimos 7 dias',
        last_30_days: 'Últimos 30 dias',
        this_month: 'Este mês',
        last_month: 'Mês passado'
      }
    },
    security: {
      monitoring: {
        menu: 'Monitoramento'
      },
      access_logs: {
        title: 'Logs de acesso',
        block_ip: 'Bloquear IP'
      },
      dashboard: {
        title: 'Dashboard',
        filters: {
          start_date: 'Data Inicial',
          end_date: 'Data Final',
          refresh: 'Atualizar'
        },
        metrics: {
          total_requests: 'Total de Requisições',
          unique_ips: 'IPs Únicos',
          error_requests: 'Requisições com Erro',
          blocked_ips: 'IPs Bloqueados'
        },
        charts: {
          requests_timeline: 'Requisições ao Longo do Tempo',
          requests_by_status: 'Requisições por Status Code',
          requests_by_method: 'Requisições por Método HTTP',
          requests: 'Requisições'
        },
        top_ips: 'Top 10 IPs',
        top_urls: 'Top 10 URLs',
        top_urls_4xx: 'Top 10 URLs com erro 4xx',
        top_urls_5xx: 'Top 10 URLs com erro 5xx',
        table: {
          ip: 'IP',
          url: 'URL',
          total_requests: 'Total de Requisições'
        },
        messages: {
          error_title: 'Erro',
          error_loading: 'Não foi possível carregar os dados do dashboard',
          no_chart_data: 'Não há dados para exibir no período selecionado'
        }
      },
      requests: {
        title: 'Requisições',
        filters: {
          start_date: 'Data Inicial',
          end_date: 'Data Final',
          request_method: 'Método HTTP',
          status_code: 'Código HTTP',
          method_all: 'Todos',
          status_all: 'Todos',
          status_4xx: '4xx (erro cliente)',
          status_5xx: '5xx (erro servidor)',
          apply: 'Aplicar Filtros',
          clear: 'Limpar',
          refresh: 'Atualizar'
        },
        columns: {
          created_at: 'Data/Hora',
          ip: 'IP',
          url: 'URL',
          request_method: 'Método',
          status_code: 'Status',
          response_time: 'Tempo de Resposta (ms)',
          user: 'Usuário',
          actions: 'Ações'
        },
        view_meta_data: 'Visualizar Metadados',
        view_request_data: 'Visualizar Requisição',
        meta_data_modal: {
          title: 'Metadados da Requisição',
          no_data: 'Nenhum dado de metadados disponível para esta requisição',
          request_datetime: 'Data/hora da requisição',
          url: 'URL',
          request_method: 'Método',
          user_id: 'ID do usuário',
          user_name: 'Nome',
          user_email: 'E-mail',
          copy_text: 'Copiar metadados como texto',
          copy_text_success_title: 'Texto copiado',
          copy_text_success_text: 'Cabeçalho do usuário e JSON foram copiados para a área de transferência.',
          copy_text_error_title: 'Não foi possível copiar',
          copy_text_error_text: 'Verifique permissões do navegador ou copie manualmente.'
        },
        request_data_modal: {
          title: 'Dados da Requisição',
          no_data: 'Nenhum dado de requisição disponível',
          request_datetime: 'Data/hora da requisição',
          url: 'URL',
          request_method: 'Método',
          user_id: 'ID do usuário',
          user_name: 'Nome',
          user_email: 'E-mail',
          copy_text: 'Copiar requisição como texto',
          copy_text_success_title: 'Texto copiado',
          copy_text_success_text: 'URL, dados do usuário e JSON da requisição foram copiados.',
          copy_text_error_title: 'Não foi possível copiar',
          copy_text_error_text: 'Verifique permissões do navegador ou copie manualmente.'
        }
      },
      ips: {
        title: 'Análise de IPs',
        detail: 'Detalhes do IP',
        search_ip: 'Buscar IP',
        enter_ip: 'Digite o endereço IP',
        analyze: 'Analisar',
        analyzing: 'Analisando IP...',
        clear: 'Limpar',
        no_ip_selected: 'Nenhum IP selecionado',
        enter_ip_to_analyze: 'Digite um endereço IP acima para começar a análise',
        blocked: 'Bloqueado',
        not_blocked: 'Não Bloqueado',
        block_ip: 'Bloquear IP',
        unblock_ip: 'Desbloquear IP',
        confirm_unblock: 'Tem certeza que deseja desbloquear este IP?',
        error: 'Erro',
        please_enter_ip: 'Por favor, digite um endereço IP',
        error_loading_data: 'Erro ao carregar dados do IP',
        block_info: 'Informações do Bloqueio',
        location: {
          title: 'Localização',
          city: 'Cidade',
          state: 'Estado / Região',
          country: 'País',
          postal_code: 'CEP',
          timezone: 'Fuso horário',
          latitude: 'Latitude',
          longitude: 'Longitude',
          view_map: 'Ver no mapa'
        },
        urls: {
          title: 'URLs Acessadas',
          description: 'Lista de URLs acessadas por este IP',
          order_by: 'Ordenar por',
          order_by_date: 'Data (mais recente primeiro)',
          order_by_requests: 'Quantidade de requisições',
          first_request: 'Primeira Requisição',
          last_request: 'Última Requisição',
          avg_response_time: 'Tempo Médio de Resposta',
          load_more: 'Carregar Mais',
          loading: 'Carregando...',
          showing: 'Exibindo {from}–{to} de {total} URLs',
          per_page: 'Por página',
          empty: 'Nenhuma URL encontrada para este IP'
        },
        metrics: {
          total_requests: 'Total de Requisições',
          avg_response_time: 'Tempo Médio de Resposta',
          first_request: 'Primeira Requisição',
          last_request: 'Última Requisição'
        },
        charts: {
          status_codes: 'Distribuição de Status Codes',
          methods: 'Distribuição de Métodos HTTP'
        },
        columns: {
          url: 'URL',
          total_requests: 'Total de Requisições'
        },
        users: 'Usuários que usaram este IP',
        load_analysis: 'Carregar Análise Detalhada',
        loading_analysis: 'Carregando análise...',
        users_columns: {
          user_id: 'ID Usuário',
          user_name: 'Nome',
          user_email: 'Email',
          first_request: 'Primeira Requisição',
          last_request: 'Última Requisição',
          total_requests: 'Total de Requisições',
          actions: 'Ações',
          view_requests: 'Visualizar requisições deste usuário com este IP',
          view_analysis: 'Ver análise detalhada',
          risk_level: 'Nível de Risco'
        },
        risk_levels: {
          critical: 'Crítico',
          high: 'Alto',
          medium: 'Médio',
          low: 'Baixo'
        },
        user_analysis: {
          title: 'Análise Detalhada do Usuário',
          other_user: 'Outro Usuário',
          simultaneous: 'Uso Simultâneo',
          sequential: 'Uso Sequencial',
          overlap_percentage: 'Sobreposição (%)',
          yes: 'Sim'
        }
      },
      blocked_ips: {
        title: 'IPs Bloqueados',
        create_title: 'Bloquear IP',
        edit_title: 'Editar Bloqueio de IP',
        reason_n_attempts: 'N tentativas',
        analyze_ip: 'Analisar IP',
        permanent: 'Permanente',
        duration_minutes: '{minutes} min',
        columns: {
          ip: 'IP',
          reason: 'Motivo',
          attempts: 'Quantidade',
          http_codes: 'Cód. HTTP',
          blocked_by: 'Bloqueado por',
          created_at: 'Data de Bloqueio',
          duration: 'Tempo de expiração',
          expires_at: 'Data de Expiração',
          status: 'Status'
        },
        status: {
          active_permanent: 'Ativo (Permanente)',
          active_temporary: 'Ativo (Temporário)',
          inactive: 'Inativo',
          expired: 'Expirado'
        },
        form: {
          ip: 'Endereço IP',
          reason: 'Motivo do Bloqueio',
          temporary_block: 'Bloqueio Temporário',
          expires_at: 'Data de Expiração',
          select_expiration_date: 'Selecione a data de expiração',
          is_active: 'Ativo'
        }
      },
      ip_block_settings: {
        title: 'Bloqueio automático por tentativas',
        description: 'Após N tentativas falhas nos códigos HTTP configurados, o IP é bloqueado automaticamente pelo tempo T.',
        enabled: 'Ativar bloqueio automático',
        max_attempts: 'Tentativas (N)',
        max_attempts_help: 'Quantidade de falhas no intervalo para bloquear o IP',
        window_seconds: 'Intervalo (segundos)',
        window_seconds_help: 'Janela de tempo, em segundos, para contar as tentativas',
        block_duration_minutes: 'Tempo de bloqueio (T)',
        block_duration_minutes_help: 'Duração do bloqueio automático, em minutos',
        status_codes: 'Códigos HTTP de falha ou não autorizado',
        add_code: 'Adicionar outro código',
        add_code_help: 'Informe um código HTTP (100 a 599) que ainda não esteja na lista',
        add_code_placeholder: 'Ex.: 404',
        add_code_button: 'Adicionar',
        extra_codes: 'Outros códigos',
        invalid_code: 'Informe um código HTTP válido (100 a 599)',
        code_already_added: 'Este código já está na lista'
      }
    }

  }
}
